const ApiBaseUrl = {

  // Local
//apiBaseUrl: 'https://localhost:5001/api',
 //signalR base url Stage
//signalRBaseUrl: 'https://localhost:5001/notify',
 
  //  Live Server
apiBaseUrl: 'https://liveposapi.themetasum.com/api',
   //signalR base url Live
signalRBaseUrl: 'https://liveposapi.themetasum.com/notify',

//Sand Box
  //  Live Server
//apiBaseUrl: 'https://liveposapi.sumcloudpos.com/api',
   //signalR base url Live
//signalRBaseUrl: 'https://liveposapi.sumcloudpos.com/notify',


   
};

export default ApiBaseUrl;
